import { useTranslation } from 'react-i18next';

import { OrderFormProductDTO } from 'support/types';

type ProductPartsInfoProps = {
  product: OrderFormProductDTO;
  partsCount: number;
};

export function ProductPartsInfo({ product, partsCount }: ProductPartsInfoProps) {
  const { t } = useTranslation();

  return t('orderForms:form.product.partsPerUnit', {
    unit: t(`orderForms:product.unitOfMeasure.${product.unit_of_measure}`),
    count: partsCount,
  });
}

/**
 * t('orderForms:product.unitOfMeasure.EA')
 * t('orderForms:product.unitOfMeasure.GRM')
 * t('orderForms:product.unitOfMeasure.HUR')
 * t('orderForms:product.unitOfMeasure.KGM')
 * t('orderForms:product.unitOfMeasure.LTR')
 * t('orderForms:product.unitOfMeasure.MLT')
 * t('orderForms:product.unitOfMeasure.MTK')
 * t('orderForms:product.unitOfMeasure.MTR')
 * t('orderForms:product.unitOfMeasure.PCK')
 * t('orderForms:product.unitOfMeasure.SET')
 * t('orderForms:product.unitOfMeasure.CS')
 * t('orderForms:product.unitOfMeasure.CA')
 * t('orderForms:product.unitOfMeasure.DAY')
 * t('orderForms:product.unitOfMeasure.WEE')
 * t('orderForms:product.unitOfMeasure.MON')
 * t('orderForms:product.unitOfMeasure.CT')
 * t('orderForms:product.unitOfMeasure.CQ')
 * t('orderForms:product.unitOfMeasure.CU')
 * t('orderForms:product.unitOfMeasure.BJ')
 * t('orderForms:product.unitOfMeasure.BO')
 * t('orderForms:product.unitOfMeasure.MTQ')
 * t('orderForms:product.unitOfMeasure.PF')
 * t('orderForms:product.unitOfMeasure.BG')
 * t('orderForms:product.unitOfMeasure.RO')
 * t('orderForms:product.unitOfMeasure.TNE')
 * t('orderForms:product.unitOfMeasure.BE')
 * t('orderForms:product.unitOfMeasure.CMT')
 * t('orderForms:product.unitOfMeasure.KMT')
 * t('orderForms:product.unitOfMeasure.PR')
 * t('orderForms:product.unitOfMeasure.TU')
 * t('orderForms:product.unitOfMeasure.COL')
 */
